// -- other --
import React,{useState,useEffect,useRef} from "react";
import {Link} from "react-router-dom";
import Select from "react-select";
import {all_routes} from "../../../../router/all_routes";
import {Toaster} from 'react-hot-toast';
// -- biz9  --
import {Log,Str} from "biz9-utility";
import {Message,Title,Project_Table} from "../../../../../constant";
import {App,Toast_Message,Style} from "../../../../../project";
import {Portal_Url,Portal_Remote_Data} from "biz9-portal-app";
import {Data_Logic} from "biz9-data-app";
const App_Status_Type_Edit_Modal = (props) => {
    const [app,setApp] = useState(Data_Logic.get(Project_Table.APP,0));
    const [val_sub_page_title,setValSubPageTitle] = useState("Edit System Status");
    const [status_types,setStatusTypes] = useState(App.get_app_status_types());
    const [sel_status_type,setSelStatusType] = useState(null);
    useEffect(() => {
        if(props){
            bind_items(props);
        }
    },[props]);
    async function bind_items(props)
    {
        // -- status-type --
        setSelStatusType(status_types.find(option => option.value === App.get_app_status_type_by_type(props.app.status_type).value));
        // -- app --
        setApp(Data_Logic.get(Project_Table.APP,props.app.id));
    }
    const updateStatusType = (selectedOption) => {
        Toast_Message.loading(Message.SAVING);
        setSelStatusType(selectedOption);
        app.status_type = selectedOption.value;
        setApp(app);
        props.onUpdate(selectedOption.value);
        post_field(app);
    };
    async function post_field(app){
        // -- post-status-type -- data-response --
        const [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),Project_Table.APP,app);
        Toast_Message.success(response.message);
    };
    return (
            <>
            <Toaster />
            <div className="modal new-modal fade" id="status_type_edit_modal" data-keyboard="false" data-backdrop="static">
            <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
            <div className="modal-header">
            <h5 className="modal-title">{val_sub_page_title}</h5>
            <button type="button" className="close-btn" data-bs-dismiss="modal">
            <span>×</span>
            </button>
            </div>
            <div className="modal-body">
            <div className="row">
            <div className="col-md-12">
            <div className="amt-wrap">

            <div className="form-wrap">
            <label className="form-label mb-1 fw-medium text-dark">
            {Title.LABEL_STATUS}
            </label>
            <Select classNamePrefix="react-select" className="select" styles={Style.customStyles} value={sel_status_type} onChange={updateStatusType} placeholder={Title.LABEL_SELECT} options={status_types} />
            </div>

            </div>
            </div>
            <div className="col-md-12">
            <Link hidden={true} to="#" data-bs-dismiss="modal" className="btn btn-primary w-100">
            {Title.LABEL_SAVE}
            </Link>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </>
                );
};
export default App_Status_Type_Edit_Modal;
